import { type FC } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import Footer from '../Footer/Footer.tsx';
import footerRootQuery, {
    initialVariables,
    type footerRootQueryType,
} from '../../queries/footerRootQuery.ts';

const FooterRenderer: FC = () => {
    const data = useLazyLoadQuery<footerRootQueryType>(footerRootQuery, initialVariables, {
        fetchPolicy: 'store-only',
    });

    return <Footer viewer={data.viewer} />;
};

export default FooterRenderer;
